import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-bow-tie",
  "use": "icon-si-glyph-bow-tie-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-bow-tie\" id=\"icon-si-glyph-bow-tie\"><title>1089</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 5.000000)\" fill=\"#434343\"><g><path d=\"M0.953,5.974 C2.187,5.974 5.963,4.661 5.963,3.361 C5.963,2.061 5.963,4.01 5.963,2.656 C5.963,1.302 1.58,0.001 0.953,0.001 C-0.278,0 -0.26,5.974 0.953,5.974 L0.953,5.974 Z\" class=\"si-glyph-fill\" /><path d=\"M15.056,5.927 C13.819,5.927 10.034,4.624 10.034,3.334 C10.034,2.044 10.034,3.979 10.034,2.635 C10.034,1.29 14.429,-2.27373675e-13 15.056,-2.27373675e-13 C16.291,0 16.271,5.927 15.056,5.927 L15.056,5.927 Z\" class=\"si-glyph-fill\" /></g><rect x=\"7\" y=\"2\" width=\"1.984\" height=\"1.984\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-bow-tie.svg
// module id = Nyky
// module chunks = 62